import {
  AfterContentInit,
  AfterViewChecked,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Options, LabelType } from '@angular-slider/ngx-slider';
import { format } from 'date-fns';
import { PopoverController, ToastController } from '@ionic/angular';
import { Renderer2 } from '@angular/core';

@Component({
  selector: 'app-range-slider-date',
  templateUrl: './range-slider-date.component.html',
  styleUrls: ['./range-slider-date.component.scss'],
})
export class RangeSliderDateComponent implements OnInit, OnChanges {
  @ViewChild('popover') popover;
  @Input() yearsBack: number = 30;
  isOpen = false;
  @Input() maxValue = new Date();
  @Input() name: string = 'range';
  @Input() minValue!: Date;
  @Input() colorIcon: string = 'white';
  @Input() popoverActive!: boolean;
  rangeDate = {
    start: new Date(
      this.maxValue.getFullYear() - this.yearsBack,
      this.maxValue.getMonth(),
      this.maxValue.getDate()
    ),
    end: new Date(),
  };
  @Output() minDateEvent = new EventEmitter<Date>();
  @Output() maxDateEvent = new EventEmitter<Date>();
  @Input() isRange: boolean = true;

  dateRange: Date[] = this.obtenerRangoFechas(
    this.rangeDate.start,
    this.rangeDate.end
  );
  value!: number;
  options: Options = {
    stepsArray: this.dateRange.map((date: Date) => {
      return { value: date.getTime() };
    }),
    translate: (value: number, label: LabelType): string => {
      // Puedes reemplazar el siguiente texto con el que desees mostrar en la etiqueta
      return "";
    },
  };
  public isToastOpen = false;
  public message = '';
  public id: string = this.name+this.getComponentInstanceId();
  public show = false;
  value1: string = ''
  value2: string = ''
  settingDate = {
    start: this.getDate(this.value, this.isRange),
    end: this.getDate(this.maxValue.getTime())
  }
  constructor(
    private popoverController: PopoverController,
    private toast: ToastController,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
   if(changes['yearsBack']?.currentValue){
    this.changeRange(false)
   }
  }

  ngOnInit() {
    this.show = true;
    this.value = this.minValue.getTime();
    this.value1 = this.getDate(this.value, this.isRange)
    this.value2 = this.getDate(this.maxValue.getTime())
    this.settingDate = {
      start: this.getDate(this.rangeDate.start.getTime(), this.isRange),
      end: this.getDate(this.rangeDate.end.getTime())
    }
    setTimeout(() => {
      this.ajust('text-min'+this.id, 'ngx-slider-model-value', 'min-date'+this.id);
      if (this.isRange) {
        this.ajust('text-max'+this.id, 'ngx-slider-model-high', 'max-date'+this.id);
        this.maxDateEvent.emit(this.maxValue);

        document.getElementsByClassName('ngx-slider-combined')[0].id = 'combined';
        document
          .getElementById('combined')
          ?.style.setProperty('visibility', 'hidden');
      }
  
    
      this.minDateEvent.emit(this.minValue);      
    }, 100);
  }

  obtenerRangoFechas(fechaInicio, fechaFin) {
    var fechas: Date[] = [];
    var fechaActual = new Date(fechaInicio);
    while (fechaActual.getTime() <= new Date(fechaFin).getTime()) {
      fechas.push(new Date(fechaActual));
      fechaActual.setDate(fechaActual.getDate() + 1);
    }

    return fechas;
  }


  validateDate(date: Date): any {
    return !isNaN(date.getTime())
  }

  getDate(value, isRange = true ) {
    if(!isRange){
      return value ?  new Date(value).toISOString().slice(0, 7) : new Date().toISOString().slice(0, 7);
    }
    return value ?  new Date(value).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10);
  }

  changeEnd(event) {
    this.minValue = new Date(event.value);
    this.minDateEvent.emit(this.minValue);
    this.ajust('text-min'+this.id, 'ngx-slider-model-value', 'min-date'+this.id);
    this.value1 = this.getDate(this.minValue.getTime(), this.isRange)
    
    if (this.isRange) {
      this.maxValue = new Date(event.highValue);
      this.ajust('text-max'+this.id, 'ngx-slider-model-high', 'max-date'+this.id);
      this.value2 = this.getDate(this.maxValue.getTime())
      this.maxDateEvent.emit(this.maxValue);
    }
  }

  private getComponentInstanceId(): string {
    // Genera un identificador único basado en el número de instancia del componente
    return Date.now().toString(); // Puedes ajustar esto según tus necesidades
  }

  ajust(id, className: string, newId: string) {
    const test2 = document.querySelector('.'+this.id)
    const t = test2?.querySelectorAll('.'+className)
  
    if(t){
      t[0].id = id;
    }
   
    const spanElement = document.getElementById(id);
    const custom = document.getElementById(newId);
    custom?.style.setProperty(
      'left',
      spanElement?.style.left.toString() as any
    );
    custom?.style.setProperty('top', '0px');
    custom?.style.setProperty('opacity', '1');
    newId === 'min-date'+this.id && custom?.style.setProperty('top', '69px');
    spanElement?.style.setProperty('opacity', '0');
  }

  setMaxValue(event) {
    this.maxValue = new Date(event.target.value);
    this.maxValue.setMinutes(this.maxValue.getMinutes() + this.maxValue.getTimezoneOffset())
    this.maxDateEvent.emit(this.maxValue)
  
  }
  setMinValue(event) {
    this.minValue = new Date(event.target.value);
    this.minValue.setMinutes(this.minValue.getMinutes() + this.minValue.getTimezoneOffset())
    this.value = this.minValue.getTime();
    this.minDateEvent.emit(this.minValue)
  }

  changeRange(popover: boolean = true) {
    
    if(!this.popover){
      this.rangeDate.start =  new Date(
        this.maxValue.getFullYear() - this.yearsBack,
        this.maxValue.getMonth(),
        this.maxValue.getDate()
      )
    }
  
    if (this.rangeDate.start.getTime() > this.rangeDate.end.getTime()) {
      this.setOpen(true);
      this.message =
        'Por favor, asegúrate de ingresar un rango de fechas válido. La fecha de inicio no puede ser posterior a la fecha final. ';
    } else {
      this.maxValue = this.rangeDate.end;
      this.minValue = new Date(
        this.maxValue.getFullYear() - 1,
        this.maxValue.getMonth(),
        this.maxValue.getDate()
      );
      this.dateRange = this.obtenerRangoFechas(
        this.rangeDate.start,
        this.rangeDate.end
      );

      const newOptions: Options = {
        stepsArray: this.dateRange.map((date: Date) => {
          return { value: date.getTime() };
        }),
        translate: (value: number, label: LabelType): string => {
          return "";
        },
      };

      this.options = newOptions;
      popover && this.closePopover();
    }
  }

  setRangeDateStart(event) {
    this.rangeDate.start = new Date(event.target.value);
    this.setSettingDate()
  }

  setRangeDateEnd(event) {
    this.rangeDate.end = new Date(event.target.value);
    this.setSettingDate()
  }

  setSettingDate(){
    this.settingDate = {
      start: this.getDate(this.rangeDate.start.getTime(), this.isRange),
      end: this.getDate(this.rangeDate.end.getTime())
    }
  }
  closePopover() {
    this.popoverController.dismiss();
  }

  setOpen(isOpen: boolean) {
    this.isToastOpen = isOpen;
  }
  presentPopover(e: Event) {
    this.popover.event = e;
    this.isOpen = true;
  }
}
